// extracted by mini-css-extract-plugin
export default {"container":"ApprovalTasksNotification-module__container--uizUQ","subTitle":"ApprovalTasksNotification-module__subTitle--LiHQm"};